import { render, staticRenderFns } from "./Actiuni_list.vue?vue&type=template&id=4d011968&scoped=true"
import script from "./Actiuni_list.vue?vue&type=script&lang=js"
export * from "./Actiuni_list.vue?vue&type=script&lang=js"
import style0 from "./Actiuni_list.vue?vue&type=style&index=0&id=4d011968&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d011968",
  null
  
)

export default component.exports